import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toasts: [],
  globalLoading: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.toasts.push({ id: Date.now(), ...action.payload });
    },
    hideToast: (state, action) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload;
    },
  },
});

export const { showToast, hideToast, setGlobalLoading } = uiSlice.actions;

export const selectToasts = (state) => state.ui.toasts;
export const selectGlobalLoading = (state) => state.ui.globalLoading;

export default uiSlice.reducer;
